import React from "react";
import "./daoHero.css";
export default function DaoHero() {
  return (
    <div className="dao-container container-fluid">
      <div className="row py-5">
        <div className="col-12 col-md-7 ps-md-5 ">
          <h1 className="dao-title text-start">Dao</h1>
          <p className="dao-para text-start">
            Building VirtualEx's full community autonomy Entering the
            <span className="web3 ms-1">Web 3.0</span> Era in the Blockchain
            Field
          </p>
          <button className="btn-dao">Join our Dao</button>
        </div>
      </div>
    </div>
  );
}
